
import { tokenState, userState } from '@/services/auth';
import { apiUrl, axiosAuthPost, errorHandling } from '@/services/utils'
import { defineComponent } from 'vue'

export default defineComponent({
    setup() {

    },
    data() {
        return {
            outing:false
        }
    },
    methods: {
        logout() {
            let logoutUrl = apiUrl + 'auth/logout';
            this.outing = true;
            axiosAuthPost(logoutUrl, {}).then((result) => {
                userState.clearAuth();
                this.$emit('hideMenu');
                this.$router.push('/login');
                this.outing = false;
            }).catch((err) => {
                errorHandling(err);
                this.outing = false;
            });
        },
        hideMenu() {
            this.$emit('hideMenu');
        }
    }
})
